import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class RegistryEntriesService {
  constructor(private http: HttpClient) {
  }

  list(params?: {}): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/registries/entries`, {params: params});
  }

  show(id: string, params?: {}): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/registries/entries/${id}`, {params: params});
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/api/registries/entries/${id}`);
  }

  move(id: string, data: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/api/registries/entries/${id}`, data);
  }

}
